<div class="step-header">
  <div class="title" *ngIf="selectedAppId === 0">Choose an application to add thresholds</div>
  <div class="title" *ngIf="selectedAppId > 0">Selected application</div>
</div>
<div class="content" *ngIf="!wizardCtrl.getWizardService().isLoading">
  <div class="app-filter" *ngIf="selectedAppId === 0">
    <div class="app-filter-wrapper">
      <div class="search-icon"><mat-icon>search</mat-icon></div>
      <input autocomplete="off" matInput class="searchInput" placeholder="Search" [(ngModel)]="searchText" (ngModelChange)="onSearchTextChange($event)">
    </div>
  </div>
  <div class="app-list-container" *ngIf="selectedAppId === 0">
    <div class="app-list" >
      <div class="app-list-item" *ngFor="let item of dataSource" (click)="chooseApp(item)" >
        <div class="app-name title">{{item.name}}</div>
      </div>
    </div>
  </div>
  <div class="selected-app-list" *ngIf="selectedAppId > 0">
    <div class="icon"><mat-icon>apps</mat-icon></div>
    <div class="app-list-item" >
      <div class="app-name title">{{selectedAppName}}</div>
    </div>
    <div class="action">
      <button mat-raised-button class="btn btn-blue" (click)="resetSelectedAppInformation()">CHANGE</button>
    </div>
  </div>
</div>
<div *ngIf="wizardCtrl.getWizardService().isLoading" class="loader">
  <div class="loader-msg-header">
    <p>Loading Available Application...</p>
  </div>
  <mat-spinner></mat-spinner>
  <div class="loader-msg">One moment, please.</div>
</div>
